import { Link } from "react-router-dom";
import { useState, useRef } from "react";
import Lottie from "lottie-react";
import eyeAnimation from "./eyeAnimation.json";

const Field = ({
    className,
    classInput,
    label,
    children,
    textarea,
    type,
    forgotPassword,
    ...inputProps
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const lottieRef = useRef();
    const isPasswordField = type === "password";
    const inputType = isPasswordField && showPassword ? "text" : type;

    const handleToggle = () => {
        if (isAnimating) return; // Prevent clicks during animation
        
        setIsAnimating(true);
        
        if (lottieRef.current) {
            if (showPassword) {
                // Hiding password: play backward animation first, then hide
                lottieRef.current.setDirection(-1);
                lottieRef.current.play();
            } else {
                // Showing password: play forward animation first, then reveal  
                lottieRef.current.setDirection(1);
                lottieRef.current.play();
            }
        } else {
            // Fallback if lottie ref is not ready
            setShowPassword(!showPassword);
            setIsAnimating(false);
        }
    };

    const handleAnimationComplete = () => {
        console.log('Animation completed');
        // Change password visibility after animation completes
        setShowPassword(prev => !prev);
        setIsAnimating(false);
    };

    return (
        <div className={`${className || ""}`}>
            {label && (
                <div className="flex items-center mb-2 text-description-2">
                    <div className="mr-auto text-white">{label}</div>
                    {forgotPassword && (
                        <Link
                            className="text-description transition-colors hover:text-white"
                            to="/reset-password"
                        >
                            Forgot password?
                        </Link>
                    )}
                </div>
            )}
            <div className={`relative ${textarea ? "text-0" : ""}`}>
                {children}
                {textarea ? (
                    <textarea
                        className={`w-full h-20 px-5.5 py-4 border-[1px] border-line rounded-xl text-description-1 text-white transition-colors resize-none outline-0 focus:border-white/60 bg-transparent ${classInput || ""}`}
                        {...inputProps}
                    ></textarea>
                ) : (
                    <>
                        <input
                            className={`w-full h-11 px-5.5 border-[1px] border-line rounded-xl text-description-1 text-white transition-colors outline-0 focus:border-white/60 bg-transparent ${isPasswordField ? 'pr-12' : ''} ${classInput || ""}`}
                            type={inputType || "text"}
                            {...inputProps}
                        />
                        {isPasswordField && (
                            <button
                                type="button"
                                onClick={handleToggle}
                                className="absolute right-4 top-1/2 -translate-y-1/2 text-description hover:text-white transition-colors focus:outline-none disabled:opacity-50"
                                aria-label={showPassword ? "Hide password" : "Show password"}
                                disabled={isAnimating}
                            >
                                <Lottie
                                    lottieRef={lottieRef}
                                    animationData={eyeAnimation}
                                    loop={false}
                                    autoplay={false}
                                    speed={1.7}
                                    onComplete={handleAnimationComplete}
                                    style={{ width: 20, height: 20 }}
                                />
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default Field;
